import React from 'react'
import { useMedia, useMemo } from 'sb-hooks'
import cx from 'classnames'
import formatPrice from 'helpers/modifiers/formatPrice'

import Box from 'components/_new/layout/Box/Box'
import Carousel from 'components/ui/Carousel/Carousel'

import UpgradeMonthlyPlan from 'components/upgradePlans/cards/UpgradeMonthlyPlan/UpgradeMonthlyPlan'
import UpgradePrepaidPlan from 'components/upgradePlans/cards/UpgradePrepaidPlan/UpgradePrepaidPlan'


import s from './UpgradePlans.scss'


const UpgradePlans = (props) => {
  const { className, plans, planClassName, carouselOptions: customOptions, onPlanSelect } = props
  const { isMobile } = useMedia()

  const items = plans.map((plan) => {
    const { name, className, billingPeriod } = plan

    const props = {
      isMobile,
      key: name,
      className: cx(className, planClassName, s.plan),
      data: plan,
      onButtonClick: onPlanSelect,
    }

    if (billingPeriod > 1) {
      return (
        <UpgradePrepaidPlan {...props} />
      )
    }

    return (
      <UpgradeMonthlyPlan {...props} />
    )
  })

  const carouselOptions = useMemo(() => ({
    className: s.carousel,
    arrows: false,
    swipe: true,
    touchMove: true,
    dots: true,
    variableWidth: true,
    ...(customOptions || {}),
  }), [ customOptions ])

  return (
    <Box className={s.container} pt="16">
      {
        isMobile ? (
          <Carousel options={carouselOptions}>
            {items}
          </Carousel>
        ) : (
          <div className={cx(className, s.list)}>
            {items}
          </div>
        )
      }
    </Box>
  )
}


export default UpgradePlans
